<div *ngIf="data" class="generic-text-block {{data.style}}" [ngClass]="{'symbol-present': data.symbol}">
    <finder-component-header *ngIf="data?.title || data?.subtitle as hasHeader"
        [data]="data"
        [hrDecoration]="data.hrDecoration"
    ></finder-component-header>
    <div class="symbol" *ngIf="data.symbol">
        <finder-font-icon
            svg="true"
            size="l"
            [name]="data.symbol"
        ></finder-font-icon>
    </div>
    <div *ngIf="data.text"
        class="generic-text dynamic-html desktop-{{data?.textAlignment || defaultAlignment }}
            mobile-{{data?.mobileTextAlignment || data?.textAlignment || defaultAlignment }}"
        [innerHtml]="data.text | safeHtml"
    ></div>
</div>
